// extracted by mini-css-extract-plugin
module.exports = {"directoryCard":"DirectoryCard_directoryCard__CLGN8","cardText":"DirectoryCard_cardText__3FQhZ","isActive":"DirectoryCard_isActive__jkspz"};